var map = {
	"./birdsbeasts_en.png": "ZDGG",
	"./birdsbeasts_esp.png": "9hp5",
	"./birdsbeasts_th.png": "UONs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/ER9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/birdsbeasts_.*\.png$
// module id = /ER9
// module chunks = 1